module.exports = __webpack_public_path__ + "static/img/game-logo-bbin.71cf37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-bbin.png
// module id = ELoL
// module chunks = 0 1 2 3 4 5 6